<template>
    <div class="returnCostSchemeConfig">
      <el-row class="returncycleFee">
        <el-col>周期缴费单生成时间</el-col>
      </el-row>
      <el-row>
        <el-col :span=12>
          <el-row class="textalign">周期缴费单生成方式:</el-row>
          <el-row class="width75">
            <el-select v-model="style">
              <el-option
                v-for="item in styleOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-row>
        </el-col>
        <el-col :span=12>
          <el-row class="textalign">周期缴费单生成时间:</el-row>
          <el-row class="width75">
            <el-select v-model="time">
              <el-option
                v-for="item in timeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-row>
        </el-col>
      </el-row>
      <el-row class="button">
        <el-button type="primary" @click.native="submit">保存</el-button>
      </el-row>
    </div>
</template>
<script>
export default {
  name:"BillGenerationCycleConfig",
  components:{},
  data(){
    return {
      style:"",
      styleOptions:[
        { value: 1, label: "手动生成" },
        { value: 2, label: "自动生成" }
      ],
      time:"",
      timeOptions: Array.from({ length: 28 }, (_, i) => ({ value: i + 1, label: `每月${i + 1}号` })),
      ruleId: null,
    }
  },
  methods:{
    submit(){
      let params = {
        homeId: Number(sessionStorage.getItem("groupId")),
        billGenMode: this.style,
        billGenDay: this.time
      };
      if (this.ruleId) params.id = this.ruleId;
      this.$postJson("fmc/billingRule/save", params).then(res => {
        if (res.code == 200) {
          this.$message({ message: "保存成功", type: "success" });
          this.queryConfig();
        } else {
          this.$message({ message: res.message || "保存失败", type: "error" });
        }
      });
    },
    queryConfig(){
      let params = { homeId: Number(sessionStorage.getItem("groupId")) };
      this.$postJson("fmc/billingRule/getByHomeId", params).then(res => {
        if (res.code == 200 && res.result) {
          this.ruleId = res.result.id;
          this.style = res.result.billGenMode || "";
          this.time = res.result.billGenDay || "";
        }
      });
    }
  },
  created(){
    this.queryConfig();
  },
  mounted(){
    
  }
}
</script>
<style lang="scss" scoped>
  .returnCostSchemeConfig{
    .returncycleFee{
      height:50px;
      line-height:50px;
      font-size:18px;
      font-weight:700;
    }
    .textalign{
      text-align: center;
      height:50px;
      line-height: 50px;
    }
    .width75{
      width:35%;
      margin:0 auto;
    }
    .button{
      height:100px;
      line-height: 100px;
      margin: 100px;
      text-align:center;
    }
  }
</style>